export const catalogos = [
    { id: 1, descripcion: 'Distrito judicial', path: '/catalogos/distritoJudicial/' },
    { id: 2, descripcion: 'Juzgado', path: '/catalogos/juzgado/' },
    { id: 3, descripcion: 'Tipo sesión', path: '/catalogos/tipoSesion/' },
    { id: 4, descripcion: 'Tipo usuario', path: '/catalogos/tipoUsuario/' },
    { id: 5, descripcion: 'Estatus', path: '/catalogos/estatus/' },
    { id: 6, descripcion: 'Materia', path: '/catalogos/materia/' },
    { id: 7, descripcion: 'Tipo movimiento', path: '/catalogos/tipoMovimiento/' },
];